export default function PlayIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="rgba(255,255,255,.9)">
      <circle cx="12" cy="12" r="10" />
      <polygon points="10 8 16 12 10 16 10 8" fill="#000" />
    </svg>
  );
}
